import { render, staticRenderFns } from "./FbPage.vue?vue&type=template&id=32cea266"
import script from "./FbPage.vue?vue&type=script&lang=js"
export * from "./FbPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports